import React from 'react';
import './Header.css';

const Header = (): JSX.Element => {
  return (
    <header className="Header">
      <h2>RESTlr</h2>
    </header>
  );
};

export default Header;
